import { defineMessages } from 'react-intl';

export const estimationItemsTableMessageDefinitions = defineMessages({
  estimate: {
    id: 'estimationDetail.estimationItemsCostSummarySummaryTable.estimate',
    defaultMessage: 'Estimate',
  },
  totalSum: {
    id: 'estimationDetail.estimationItemsCostSummarySummaryTable.subtotal',
    defaultMessage: 'Subtotal',
  },
});
